import { render } from "./BookLight.vue?vue&type=template&id=7818ada8&scoped=true"
import script from "./BookLight.vue?vue&type=script&lang=js"
export * from "./BookLight.vue?vue&type=script&lang=js"

import "./BookLight.vue?vue&type=style&index=0&id=7818ada8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7818ada8"]])

export default __exports__